export default __webpack_public_path__ + "static/media/bust.9db63efc.svg";